// api/services/Client.js
import { apiClient } from "../../base/ApiClient";

export const fetchClients = async (currentPage, search, candidate, location, carePlanFilter) => {
  const params = new URLSearchParams();
  params.append("page", currentPage);

  if (search) params.append("search", search);
  if (candidate) params.append("candidate", candidate);
  if (location) params.append("location", location);
  
  if (carePlanFilter && carePlanFilter !== "all") {
    params.append("type", carePlanFilter);
  }

  const response = await apiClient.get(`/client/clients/?${params.toString()}`);
  return response.data;
};

export const searchClients = async (search) => {
  const response = await apiClient.get(`/client/search/?search=${search}`);
  return response.data;
};

export const fetchClient = async (id) => {
  const response = await apiClient.get(`/client/clients/${id}/`);
  return response.data;
};

export const updateClient = async (id, data) => {
  const response = await apiClient.put(`/client/clients/${id}/`, data);
  return response.data;
};

export const patchClient = async (id, data) => {
  const response = await apiClient.patch(`/client/clients/${id}/`, data);
  return response;
};

export const getPersonalDetailsSummary = async (clientId) => {
  const response = await apiClient.get(`/client/personal-details-summary/?client_id=${clientId}`);
  return response.data;
};

export const createPersonalContact = async (formData) => {
  const response = await apiClient.post(`/client/personal-contacts/`, formData);
  return response.data;
};

export const updatePersonalContact = async (contactId, formData) => {
  const response = await apiClient.put(
    `/client/personal-contacts/${contactId}/`,
    formData
  );
  return response.data;
};

export const getPersonalContacts = async () => {
  const response = await apiClient.get(`/client/personal-contacts/`);
  return response.data;
};

export const deletePersonalContact = async (contactId) => {
  const response = await apiClient.delete(
    `/client/personal-contacts/${contactId}/`
  );
  return response.data;
};

export const getPersonalContactById = async (contactId) => {
  const response = await apiClient.get(
    `/client/personal-contacts/${contactId}/`
  );
  return response.data;
};

export const createGPContact = async (formData) => {
  const response = await apiClient.post(`/client/gp-contacts/`, formData);
  return response.data;
};

export const getGPDetails = async (client_id) => {
  const response = await apiClient.get(
    `/client/gp-contacts/?client_id=${client_id}`
  );
  return response.data;
};

export const getGPContactById = async (contactId) => {
  const response = await apiClient.get(`/client/gp-contacts/${contactId}/`);
  return response.data;
};

export const updateGPContact = async (contactId, formData) => {
  const response = await apiClient.put(
    `/client/gp-contacts/${contactId}/`,
    formData
  );
  return response.data;
};

export const deleteGPContact = async (contactId) => {
  const response = await apiClient.delete(`/client/gp-contacts/${contactId}/`);
  return response.data;
};

export const createProfessionalContact = async (formData) => {
  const response = await apiClient.post(
    `/client/professional-contacts/`,
    formData
  );
  return response.data;
};

export const getProfessionalDetails = async () => {
  const response = await apiClient.get(`/client/professional-contacts/`);
  return response.data;
};

export const getProfessionalContactById = async (contactId) => {
  const response = await apiClient.get(
    `/client/professional-contacts/${contactId}/`
  );
  return response.data;
};

export const updateProfessionalContact = async (contactId, formData) => {
  const response = await apiClient.put(
    `/client/professional-contacts/${contactId}/`,
    formData
  );
  return response.data;
};

export const deleteProfessionalContact = async (contactId) => {
  const response = await apiClient.delete(
    `/client/professional-contacts/${contactId}/`
  );
  return response.data;
};

export const createFundingProfile = async (formData) => {
  const response = await apiClient.post(`/client/funding-profiles/`, formData);
  return response.data;
};

export const getFundingProfiles = async (clientID) => {
  const response = await apiClient.get(
    `/client/funding-profiles/?client_id=${clientID}`
  );
  return response.data;
};

export const getFundingProfileById = async (fundingId) => {
  const response = await apiClient.get(
    `/client/funding-profiles/${fundingId}/`
  );
  return response.data;
};

export const updateFundingProfile = async (fundingId, formData) => {
  const response = await apiClient.put(
    `/client/funding-profiles/${fundingId}/`,
    formData
  );
  return response.data;
};

export const deleteFundingProfile = async (fundingId) => {
  const response = await apiClient.delete(
    `/client/funding-profiles/${fundingId}/`
  );
  return response.data;
};

export const getClientArea = async (clientId) => {
  const response = await apiClient.get(`/client/${clientId}/area/`);
  return response.data;
};